<template>
  <div style="min-height: 150px">
    <div style="padding: 15px 10px;">
      <span style="display:inline-block;margin:0 0 20px 0">  配送至：{{ address.province }}  {{ address.city }} {{ address.county }}{{ address.receiptAddress }}</span>
      <el-table :data="tableData" border style="width: 100%" :summary-method="getSummaries" show-summary>
        <el-table-column type="index" width="50" label="序号" align="left" fixed="left" />
        <el-table-column prop="productCode" label="销售产品代码" align="left" min-width="150" />
        <el-table-column prop="productInvoiceName" label="商品名称" align="left" min-width="150" />
        <el-table-column prop="productName" label="规格型号" align="left" min-width="150" />
        <el-table-column prop="counct" label="数量" align="left" width="60">
          <template v-slot="{row}">
            {{ Number(row.counct).toFixed(0) }}
          </template>
        </el-table-column>
        <el-table-column prop="productUnit" label="单位" align="left" width="60" />

        <el-table-column prop="pname" label="是否购买PSC" align="left">
          <template v-slot="{row}">
            {{ row.buyPsc=='Y'?'是':row.buyPsc=='N'?'否':'' }}
          </template>
        </el-table-column>
        <el-table-column prop="isBorrow" label="是否冲销" align="left">
          <template v-slot="{row}">
            {{ row.isBorrow ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column prop="taxName" label="税收分类名称" align="left" width="100" />
        <el-table-column prop="taxRate" label="税率" align="right" header-align="left" width="50">
          <template v-slot="{row}">
            {{ row.taxRate }}%
          </template>
        </el-table-column>
        <el-table-column prop="pname" label="序列号" align="left" width="60">
          <template v-slot="{row}">
            <lookserial-number :str-contract-code="strContractCode" :special-product-list="row.specialProduct" :product-name="row.productName" />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script type="es6">
import lookserialNumber from './lookserialNumber';
import { getReceiptAddressByContractId, getContractProsAndSpecialPros } from '@/API';
import { MathAdd } from '@/libs/util';
export default {
  data () {
    return {
      tableData: [],
      isNoData: false,
      loading: false,
      address: [],
      exportLoading: false
    };
  },
  props: {
    strContractCode: {
      type: String,
      required: true
    }
  },
  components: {
    lookserialNumber
  },
  computed: {},
  methods: {
    initData () {
      getReceiptAddressByContractId(this.$route.query.id).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.address = json.data;
        }
      }).catch(() => {
      });
    },
    searchDetail () {
      getContractProsAndSpecialPros(this.$route.query.id, false).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data;
        }
      }).catch(() => {
      });
    },
    // 合计
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.allNum();
        }
      });
      return sums;
    },
    allNum () {
      let cont = 0;
      this.tableData.forEach((item) => {
        cont = MathAdd(cont, item.counct);
      });
      // cont = Number(cont).toFixed(2);
      return cont;
    }
  },
  mounted () {
    this.initData();
    this.searchDetail();
  }
};
</script>
